import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom"
import './App.css';
import Navigation from './Navbar';
import Top from './Top';
import Services from './Services';
import HowWeWork from './HowWeWork';
import Industries from './Industries';
import Portfolio from './Portfolio';
import About from './About';
import Contact from './Contact';
import Footer from './Footer';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';

// Legacy imports (commented out)
// import Offers from './Offers';
// import Projects from './Projects';
// import Reviews from './Reviews';
// import Project_Raffle from './Project_Raffle'
// import Project_AKA_Thailand from './Project_AKA_Thailand'
// import Project_Gelatoverse from './Project_Gelatoverse'
// import AuditingProcess from './AuditingProcess'

import { Container, Row, Col } from 'react-bootstrap'
 

function App() {

  function reveal() {
    var reveals = document.querySelectorAll(".reveal, .revealRight, .revealPop");
    for (var i = 0; i < reveals.length; i++) {
      var windowHeight = window.innerHeight;
      var elementTop = reveals[i].getBoundingClientRect().top;
      var elementVisible = 150;
      if (elementTop < windowHeight - elementVisible) {
        reveals[i].classList.add("active");
      } else {
        reveals[i].classList.remove("active");
      }
    }
  }

  window.addEventListener("scroll", reveal);

  // To check the scroll position on page load
  reveal();

  return (
    <BrowserRouter>
        <Container className="App" fluid id="wrapper">
          <Routes>
            <Route path="/" element={
              <>
                <Navigation />
                <Top />
                <Services />
                <HowWeWork />
                <Industries />
                <Portfolio />
                <About />
                <Contact text={"Have a project in mind? Let's discuss how we can help bring your vision to life."}/>
                <Footer /> 
              </>
            } />
            <Route path="/privacy-policy" element={
              <>
                <Navigation projectPage />
                <PrivacyPolicy />
                <Footer projectPage /> 
              </>
            } />
            <Route path="/terms-of-service" element={
              <>
                <Navigation projectPage />
                <TermsOfService />
                <Footer projectPage /> 
              </>
            } />
          </Routes>
        </Container>
    </BrowserRouter>
  );
}

export default App;
